import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { sumOfQuantitiesOfBomModels } from '../../prisma-xs/helpers/bom-mapper.helper';

@Pipe({
    name: 'sumBomQuantities',
    standalone: false
})
export class SumBomQuantitiesPipe implements PipeTransform {

  // eslint-disable-next-line max-len
  transform(selectedDevices: number[], bomModels: IBomModel[], bomModelsAccessories: IBomModel[], apartmentsNumber: number, selectedDevicesAccessories: number[]): number {
    return sumOfQuantitiesOfBomModels(bomModelsAccessories, selectedDevicesAccessories, apartmentsNumber) +
      sumOfQuantitiesOfBomModels(bomModels, selectedDevices, apartmentsNumber);
  }
}
